import { h } from 'preact';
import { openEditGiftBox } from '../edit/open-drawer';
export const stripEmoji = (value)=>value.replace(RegExp("\\p{Emoji_Presentation}|\\p{Extended_Pictographic}", "gu"), '');
import { openModal } from '../../theme/modal';
import { MultistepForm } from '../multistep/form';
import { saveState } from '../utils/local-storage';
import { MULTISTEP_FORM_LOCAL_STORAGE_KEY, initialContext } from '../types';
/**
 * Opens the edit gift box drawer for the given item key and scrolls to / focuses
 * the gift message textarea once the form has rendered.
 */ export const openEditGiftMessage = (itemKey, opts = {})=>{
    openEditGiftBox(itemKey, opts);
    const drawer = document.querySelector('.js-offcanvas[data-drawer-names="gift-wrapping"]');
    if (!drawer) return;
    const observer = new MutationObserver(()=>{
        const textarea = drawer.querySelector('textarea[name="giftbox_message"]');
        if (textarea) {
            observer.disconnect();
            textarea.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            textarea.focus();
        }
    });
    observer.observe(drawer, {
        childList: true,
        subtree: true
    });
};
/**
 * Opens the gift wrapping modal directly on the complimentary message step
 * and focuses the textarea.
 */ export const openComplimentaryMessage = (opts = {})=>{
    // Pre-seed localStorage so the multistep form starts on the complimentary-message step
    saveState(MULTISTEP_FORM_LOCAL_STORAGE_KEY, {
        state: 'select',
        context: {
            ...initialContext,
            giftboxGroup: 'message'
        }
    });
    var _opts_giftboxDefaultImage, _opts_giftboxProducts, _opts_diyGiftboxProducts;
    openModal(h(MultistepForm, {
        targetEl: null,
        giftboxDefaultImage: (_opts_giftboxDefaultImage = opts.giftboxDefaultImage) !== null && _opts_giftboxDefaultImage !== void 0 ? _opts_giftboxDefaultImage : null,
        giftboxProducts: (_opts_giftboxProducts = opts.giftboxProducts) !== null && _opts_giftboxProducts !== void 0 ? _opts_giftboxProducts : null,
        diyGiftboxProducts: (_opts_diyGiftboxProducts = opts.diyGiftboxProducts) !== null && _opts_diyGiftboxProducts !== void 0 ? _opts_diyGiftboxProducts : null
    }), {
        id: 'gift-wrapping-modal',
        ariaLabel: 'Gift wrapping options'
    });
    const observer = new MutationObserver(()=>{
        const textarea = document.querySelector('.gift-wrapping__message__textarea-wrap textarea');
        if (textarea) {
            observer.disconnect();
            textarea.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            textarea.focus();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
